module.exports = __webpack_public_path__ + "static/media/thoughts.0769f45b.svg";